import { HttpClientPlugin } from '../types';

export function createWithGuestHeaderPlugin(
  getGuestIdFromCookie: () => Promise<string | undefined> | string | undefined,
): HttpClientPlugin {
  return {
    async beforeRequest(url, options) {
      const { withGuestId = false } = options;
      if (!withGuestId) {
        return { url, options };
      }

      const guestId = withGuestId === true ? await getGuestIdFromCookie() : withGuestId;
      if (!guestId) {
        return { url, options };
      }

      options.headers = new Headers(options.headers);
      options.headers.set('X-Anonymous-Customer-Unique-Id', guestId);

      return { url, options };
    },
  };
}
